var React = require('react/addons');
var Table = require('react-bootstrap').Table;

var Loading = require('../Loading');

var ClientServiceEmailTable = React.createClass({
    propTypes: {
        clickHandler: React.PropTypes.func.isRequired,
        emails: React.PropTypes.arrayOf(React.PropTypes.string),
        footerButtons: React.PropTypes.node,
        readOnly: React.PropTypes.bool
    },
    render: function () {
        var emails = this.props.loading ?
            <tr><td colSpan="2"><Loading /></td></tr> :
            this.props.emails.map(function (email, key) {
                return <tr key={key}>
                    <td>{email}</td>
                    <td>
                        <div className="btn-group">
                            <button disabled={this.props.readOnly} onClick={this.props.clickHandler.bind(null, 'password', email)} className="btn btn-xs btn-warning">Password</button>
                            <button disabled={this.props.readOnly} onClick={this.props.clickHandler.bind(null, 'delete', email)} className="btn btn-xs btn-danger">Delete</button>
                        </div>
                    </td>
                </tr>;
            }.bind(this));
        if (!emails.length) {
            emails = <tr><td colSpan="2">No email accounts configured</td></tr>;
        }

        var footer;
        if (this.props.footerButtons) {
            footer = <tfoot><tr>
                <td></td>
                <td>{this.props.footerButtons}</td>
            </tr></tfoot>;
        }

        return <div className="table-responsive">
            <Table className="table-striped table-hover">
                <thead><tr>
                    <th>Email Address</th>
                    <th>Options</th>
                </tr></thead>
                <tbody>
                {emails}
                </tbody>
                {footer}
            </Table>
        </div>;
    }
})
module.exports = ClientServiceEmailTable;



// WEBPACK FOOTER //
// ./app/components/ClientServiceEmail/Table.js